import { Navigate } from 'react-router-dom';

import HistoryPage from './pages/HistoryPage.tsx';
import ConfigPage from './pages/ConfigPage.tsx';
import {
    LEGACY_VOICE_AGENT_CONFIG_PATH,
    LEGACY_VOICE_AGENT_PATH,
    LEGACY_VOICE_AGENT_RECORD_PATH,
    OVERVIEW_PATH,
    VOICE_AGENT_CONFIG_PATH,
    VOICE_AGENT_PATH,
    VOICE_AGENT_RECORD_PATH,
} from './constants.ts';
import { OVERVIEW_PATH as ASSISTANTS_OVERVIEW_PATH } from '../assistants/constants.ts';
import { legacyRedirect } from '../assistants/utils/legacyRedirect.tsx';
import { canManageVoiceAgents, canSeeVoiceAgents } from '../../users/utils.ts';

export default [
    {
        path: OVERVIEW_PATH,
        component: () => <Navigate replace to={ASSISTANTS_OVERVIEW_PATH} />,
    },
    {
        path: VOICE_AGENT_PATH,
        component: HistoryPage,
        condition: ({ user }) => canSeeVoiceAgents(user),
    },
    {
        path: VOICE_AGENT_RECORD_PATH,
        component: HistoryPage,
        condition: ({ user }) => canSeeVoiceAgents(user),
    },
    {
        path: VOICE_AGENT_CONFIG_PATH,
        component: ConfigPage,
        condition: ({ user }) => canManageVoiceAgents(user),
    },
    { path: LEGACY_VOICE_AGENT_PATH, component: legacyRedirect(VOICE_AGENT_PATH) },
    { path: LEGACY_VOICE_AGENT_RECORD_PATH, component: legacyRedirect(VOICE_AGENT_RECORD_PATH) },
    { path: LEGACY_VOICE_AGENT_CONFIG_PATH, component: legacyRedirect(VOICE_AGENT_CONFIG_PATH) },
];
